<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Campaña</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <campaign-form @save="saveCampaign"></campaign-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CampaignForm from './Forms/CampaignForm';
import swal from 'sweetalert2';

export default {
  name: 'CampaignsCreate',
  components: {
    RouteBreadCrumb,
    CampaignForm,
  },

  data() {
    return {};
  },

  methods: {
    saveCampaign(campaign) {
      this.$services
        .resource('campaigns')
        .create(campaign)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'La campaña fue creada.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'CampaignsList' }));
        });
    },
  },
};
</script>
